// --- 用户管理 --- //

export default [
  {
    name: 'serviceUserDataList',
    path: '/stadiumSuperviseSystem/:stadiumType/swimmingSuperviseStadium/userManagement/serviceUserDataList',
    meta: { title: '场馆服务用户登记表' },
    component: require('business/stadiumSuperviseSystem/userManagement/serviceUserDataList/list.vue').default
  },
  {
    name: 'waitAuditStaff',
    path: '/stadiumSuperviseSystem/:stadiumType/swimmingSuperviseStadium/userManagement/waitAuditStaff',
    meta: { title: '待审核人员' },
    component: require('business/stadiumSuperviseSystem/userManagement/waitAuditStaff/list.vue').default
  }
]
